export default __webpack_public_path__ + "static/media/share.8d8d82b3.svg";